import { useEffect } from "react";
import { getCurrentLanguage } from "util/MagnoliaAppHelpers";
import { useSetRecoilState } from "recoil";
import { useLocation } from "react-router";
import { languageState } from "state/language";
import { pagePathState } from "state/magnolia";

const LocationLanguageHandler = () => {
  // Depend on the pathname *string* rather than the location *object*: react-router
  // hands out a fresh location object on every navigation (including transient
  // history.replace calls during redirects), and re-running this effect on each
  // one is what let this component amplify redirect churn into "Maximum update
  // depth exceeded".
  const { pathname } = useLocation();
  const setLanguage = useSetRecoilState(languageState);
  const setPagePath = useSetRecoilState(pagePathState);

  useEffect(() => {
    // Functional updates that return the previous value when unchanged: Recoil
    // then skips the state write entirely (no re-render, no contentVariants
    // recompute), so this handler can never participate in an update storm.
    setLanguage((prev) => {
      const next = getCurrentLanguage();
      return prev === next ? prev : next;
    });
    setPagePath((prev) => (prev === pathname ? prev : pathname));
  }, [pathname, setLanguage, setPagePath]);

  return null;
};

export default LocationLanguageHandler;
